import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button, Field, Spinner } from "./ui/kit";
import { TYP_ZAPISU_LABEL, UCTOVANI_LABEL } from "../lib/servis";
import api, { apiError } from "../lib/api";
import Vyber from "./Vyber";

// Nový servisní zápis. Když není `zarizeni` pevně dané (ze seznamu /servis),
// necháme uživatele vybrat zařízení z péče.
export default function NovyZapisDialog({ zarizeni = null, clientId = null, onClose }) {
  const nav = useNavigate();
  const [devices, setDevices] = useState(zarizeni ? [zarizeni] : null);
  const [zid, setZid] = useState(zarizeni?.id || "");
  const [typ, setTyp] = useState("PROHLIDKA");
  const [uctovani, setUctovani] = useState("PLACENY");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (zarizeni) return;
    const params = { limit: 200 };
    if (clientId) params.client_id = clientId;
    api.get("/api/zarizeni", { params })
      .then(({ data }) => setDevices(data.items || []))
      .catch(() => setDevices([]));
  }, [zarizeni, clientId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!zid) return setError("Vyber zařízení.");
    setError(""); setSaving(true);
    try {
      const { data } = await api.post("/api/zapisy", { zarizeni_id: zid, typ_zapisu: typ, uctovani });
      nav(`/servis/zapisy/${data.id}`);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex md:items-center items-end justify-center md:p-4" data-testid="novy-zapis-dialog">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full md:max-w-[460px] md:rounded-card rounded-t-sheet shadow-panel">
        <div className="border-b border-line-softer px-6 py-4 flex items-center justify-between">
          <h2 className="text-[16px] font-800 text-ink">Nový zápis</h2>
          <button onClick={onClose} className="text-muted hover:text-ink" data-testid="novy-zapis-close"><X size={20} /></button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          {!zarizeni && (
            <Field label="Zařízení">
              {devices === null ? <div className="py-2"><Spinner /></div> : (
                <Vyber className="field" value={zid} onChange={(e) => setZid(e.target.value)} data-testid="novy-zapis-zarizeni">
                  <option value="">Vyber zařízení…</option>
                  {devices.map((d) => (
                    <option key={d.id} value={d.id}>{d.nazev}{d.client_name ? ` — ${d.client_name}` : ""}</option>
                  ))}
                </Vyber>
              )}
            </Field>
          )}
          {zarizeni && (
            <div className="rounded-card bg-inputbg px-4 py-3 text-[13px] font-600 text-ink">{zarizeni.nazev}</div>
          )}
          <Field label="Typ zápisu">
            <Vyber className="field" value={typ} onChange={(e) => setTyp(e.target.value)} data-testid="novy-zapis-typ">
              {Object.entries(TYP_ZAPISU_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </Vyber>
          </Field>
          <Field label="Účtování">
            <Vyber className="field" value={uctovani} onChange={(e) => setUctovani(e.target.value)} data-testid="novy-zapis-uctovani">
              {Object.entries(UCTOVANI_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </Vyber>
          </Field>
          {error && <div className="text-[12.5px] text-danger" data-testid="novy-zapis-error">{error}</div>}
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="ghost" onClick={onClose}>Zrušit</Button>
            <Button type="submit" disabled={saving} data-testid="novy-zapis-submit">
              {saving ? <Spinner /> : "Založit a psát"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
